import { lazy, type FC } from 'react';

import { ReactComponent as ImagesConfirmImage } from '@/assets/images/conversion/images-confirm-image.svg';
import createConverter, { CreateConverterProps } from '@/components/hoc/createConverter';
import withConfirmation from '@/components/hoc/withConfirmation';

const AdvertisingSection = lazy(() => import('@/components/conversion/footers/ImageFooter'));

const ImageConverter: FC<CreateConverterProps> = ({ children }) => {
  return (
    <div className="tw-relative tw-bg-white tw-py-5 tw-p-5 sm:tw-p-[32px] tw-border-3 tw-border-ui-light-grey tw-rounded-t-footer">
      {children}
    </div>
  );
};

export default createConverter(
  ImageConverter,
  'image',
  {
    dropzoneHeading: 'pdfextra_convert_tool.dropzone.image.heading',
    showConvertOcrButton: false,
    ConfirmationComponent: withConfirmation(ImagesConfirmImage),
  },
  AdvertisingSection
);
